import { Box } from "@mui/material";
import { Message, ListAlt } from "@mui/icons-material";
import { PrpNavigation } from "@/components/PrpNavigation/PrpNavigation";
import { PrpNavigationItem } from "@/components/PrpNavigation";
import { PrpNavigationItemHome } from "@/components/PrpNavigation/PrpNavigationItemHome";

export const CYCNavigation = () => {
  return (
    <Box
      sx={{
        "& .MuiTabs-flexContainer": {
          width: "100vw",
        },
        "& .MuiTab-root": {
          flexGrow: 0,
          flexBasis: "105px",
        },
      }}
    >
      <PrpNavigation>
        <PrpNavigationItemHome />
        <PrpNavigationItem
          item={{
            position: 1,
            path: "/cyc/progress",
            label: "Progress",
            icon: <Message />,
          }}
          tabProps={{
            sx: {
              minHeight: "85px",
              marginLeft: "calc(50% - 350px)",
              maxWidth: "180px",
            },
          }}
        />
        <PrpNavigationItem
          item={{
            position: 2,
            path: "/cyc/leaderboard",
            label: "Leaderboard",
            icon: <ListAlt />,
          }}
          tabProps={{
            sx: {
              minHeight: "85px",
              maxWidth: "180px",
            },
          }}
        />
      </PrpNavigation>
    </Box>
  );
};
